/**
 * @file annotationGroupOpen.saga.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Dec 10, 2025 16:34
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import axiosClient from 'src/services/axiosClient.js';

import standardMessages from 'src/services/notifications/standardMessages';

import {
    enqueueMessage,
} from 'src/store/actions/global.actions';


import { stringExists } from 'src/@common/utilities';

import {
    annotationEditOpenDialogSet,
} from 'src/store/actions/documentAnnotator/documentAnnotatorDb.actions';

import {
    DOCUMENT_ANNOTATOR_ANNOTATION_GROUP_OPEN_REQUEST,
    annotationGroupOpenSuccess,
    annotationGroupOpenFailure,
} from 'src/store/actions/documentAnnotator/documentAnnotatorDb.actions';

import handleSagaErrors from 'src/store/sagas/handleSagaErrors';

function callApi(payload) {
    const url = '/documentAnnotator/annotationGroupOpen';

    const baseUrl = import.meta.env.VITE_APP_API_BASE_URL;

    const config = {
        method: 'post',
        baseURL: baseUrl,
        url,
        data: {
            annotationJsonId: payload.annotationJsonId,
            annotationGroupId: payload.annotationGroupId,
            highlightAnnotation: payload.highlightAnnotation,
            pmId: payload.pmId,
            pubId: payload.pubId,
            parentDocType: payload.parentDocType,
            parentId: payload.parentId,
        },

    };

    return new Promise((resolve, reject) => {
        axiosClient(config)
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

function* createRequestSaga(action) {

    try {
        // yield put(dataLoadingSet(true));

        const resp = yield call(callApi, action.payload);

        if (stringExists(resp.payload.serverMessage)) {
            yield put(enqueueMessage(
                resp.payload.serverMessage,
                standardMessages.generalInfoMessage.options)
            );
        }

        yield put(annotationGroupOpenSuccess(resp.payload));
        yield put(annotationEditOpenDialogSet(true));

    } catch (error) {
        yield put(annotationGroupOpenFailure(error));
        handleSagaErrors(error);
    } finally {
        // yield put(dataLoadingSet(false));
    }

}

export default function* createRequestMonitor() {
    yield takeLatest(DOCUMENT_ANNOTATOR_ANNOTATION_GROUP_OPEN_REQUEST, createRequestSaga);
}
